import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { redirectionService } from "@/services/redirectionService";
import { showToast } from "@/lib/toast";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  id?: string | null;
  onCompleted?: () => void;
}

export default function ModalDeleteRedirection({
  isOpen,
  onClose,
  id,
  onCompleted,
}: Props) {
  const handleDelete = async () => {
    if (!id) return;
    try {
      const res: any = await redirectionService.remove(id);
      if (res) {
        showToast.success("Xóa chuyển hướng thành công");
        onCompleted?.();
        onClose();
      }
    } catch (e: any) {
      showToast.error(
        e?.response?.data?.message || e?.message || "Xóa thất bại"
      );
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Xác nhận xóa</DialogTitle>
        </DialogHeader>
        <p>Bạn có chắc chắn muốn xóa chuyển hướng này?</p>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Hủy
          </Button>
          <Button variant="destructive" onClick={handleDelete}>
            Xóa
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
